import styled from 'styled-components';
import Button from '@decisiv/ui-components/lib/components/Button';

// KDS Button retuned to the Actions Toolkit's look: 4px corner radius to
// match the rest of the page's controls. Colors already line up because the
// page accent (--kds-accent) is KDS's interaction primary
// (pacificOcean), so primary/secondary/ghost/danger render on-brand without
// further overrides.
//
// Variant mapping from the old custom .btn classes to KDS props:
//   .btn-primary  -> <ToolkitButton kind="primary" />            (default)
//   .btn-outline  -> <ToolkitButton kind="secondary" />
//   .btn-subtle   -> <ToolkitButton kind="secondary" />
//   .btn-ghost    -> <ToolkitButton variant="ghost" />
//   .btn-danger   -> <ToolkitButton intent="danger" />
//   .btn-sm       -> size="small"
// eslint-disable-next-line import/prefer-default-export
export const ToolkitButton = styled(Button)`
  border-radius: 4px;
`;
